import styled from 'styled-components';

export default styled.div`
	padding: var(--v-pad) var(--h-pad);
	gap: var(--v-pad);
	display: flex;
	flex-direction: column;
`;

export const StyledContactDBWrapper = styled.div`
	--v-pad: var(--spacing-x-large);
	--h-pad: var(--spacing-xxx-large);
	flex: 1;
    min-height: 0;
	display: flex;
	flex-direction: column;
`;
